
module.exports = {
  FORMAT_DATE: 'MM/DD/YYYY',
}